import React from 'react';
import { ConnectedDevicesContainer } from './ConnectedDevicesContainer';

export const AuthenticatedPageContent = () => {
  return <ConnectedDevicesContainer />;
};
